import React, {
  useState,
  useContext,
  useEffect
} from 'react';

import {
  withRouter
} from 'react-router-dom';

import {
  OTPTypes,
  VPPPopupTerms
} from 'src/Common/constants';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  tagOnDeliveryPageLoad,
  tagOnOtpError
} from 'src/Tagging/SalesTagging';

import {
  checkIsExistingUser,
  submitLead
} from 'src/Services/Services';

import {
  addBeforeloadEvent,
  removeBeforeloadEvent
} from 'src/Utility/utility';

import {
  DeliveryAddressIcon,
  SubmitLeadRequestError,
  VettingLeftArrow
} from 'src/Components/Common';

import
PersonalDetails
from 'src/Components/PersonalDetails/PersonalDetails';

import
OtpScreen
from 'src/Components/OtpScreen/OtpScreen';

import
VettingDropDown
from 'src/Components/Common/VettingDropDown/VettingDropDown';

import {
  FormFieldLabel
} from 'src/StyledComponents';

import
VPPPopup
from 'src/Components/VPPPopup/VPPPopup';

import {
  AnotherAddress,
  SameAddress
} from './components';

import
AuthInfo
from './components/AuthInfo/AuthInfo';

import
AuthInfoReview
from './components/AuthInfoReview/AuthInfoReview';

import
AuthInfoReviewMobile
from './components/AuthInfoReview/AuthInfoReviewMobile';

import './DeliveryAddress.css';

const DeliveryAddress = (props) => {

  const context = useContext(SalesContext);

  const [ showOptions, setShowOptions ] = useState(false);
  const [ selectedAddressType, setSelectedAddressType ] = useState(null);
  const [ enableNext, setEnableNext ] = useState(false);
  const [ validPersonalDetails, setValidPersonalDetails ] = useState(false);
  const [ otpScreenVisible, setOtpScreenVisible ] = useState(false);
  const [ otpSendToMessage, setOtpSendToMessage ] = useState(null);
  const [ accountBlockedMsg, setAccountBlockedMsg ] = useState(null);
  const [ hasError, setHasError ] = useState(false);
  const [ formSubmitAttempt, setFormSubmitAttempt ] = useState(0);
  const [ emailSent, setEmailSent ] = useState(false);
  const [ phoneNumberSent, setPhoneNumberSent ] = useState(false);
  const [ emailValue, setEmailValue ] = useState('');
  const [ phoneNumberValue, setPhoneNumberValue ] = useState('');
  const [ otpData, setOtpData ] = useState({});
  const [ showVPPPopup, setShowVPPPopup ] = useState(false);
  const isTargeted = context.selectedPackage.provider.toLowerCase().includes('targeted');
  const isWaiting = context.selectedPackage.provider.toLowerCase().includes('targeted');
  const agentUsername = sessionStorage.getItem('retailUserDetails') ? JSON.parse(sessionStorage.getItem('retailUserDetails')).username : null;
  window.scrollTo(0, 0);

  const isExistingUser = (isResend = false) => {

    if (!isTargeted && !isWaiting) {

      checkIsExistingUser(context)
        .then(async (res) => {

          context.setShowSpinner(true);

          if (res.result) {

            context.setUserExistingProperties({ key: 'hideBankYears', value: res.result?.hideBankYears });
            context.setUserExistingProperties({ key: 'hideVetAddress', value: res.result?.hideVetAddress });

            if (!res?.result?.isExisting) {

              window.scrollTo(0, 0);
              context.setShowSpinner(false);
              context.setIsUserExisting(false);
              props.history.push('/cloud/fibre/sales/document-notes');

            } else {

              if (res?.result?.isOrderEligible) {

                setOtpSendToMessage(res?.result?.otp?.destinationResults?.success);
                context.setExistingUserContactNumber(res?.result?.customerDetails?.phoneNumber);
                context.setShowSpinner(false);
                context.setIsUserExisting(true);
                setAccountBlockedMsg(null);

                if (res?.result?.otp?.destinationResults?.length > 0) {

                  setOtpData({ ...res?.result?.otp, isResend: isResend });

                  for (let index = 0; index < res?.result?.otp?.destinationResults?.length; index++) {

                    if (res?.result?.otp?.destinationResults[index]?.type === OTPTypes.SMS) {
                      setPhoneNumberSent(res?.result?.otp?.destinationResults[index]?.success && res?.result?.otp?.destinationResults[index]?.success);
                      setPhoneNumberValue(res?.result?.otp?.destinationResults[index]?.address);

                    } else if (res?.result?.otp?.destinationResults[index]?.type === OTPTypes.Email
                      && res?.result?.otp?.destinationResults[index]?.success
                    ) {

                      setEmailSent(res?.result?.otp?.destinationResults[index]?.success);
                      setEmailValue(res?.result?.otp?.destinationResults[index]?.address);
                    }
                  }
                }

                setOtpScreenVisible(true);
              } else {

                await context.setIsUserExisting(true);
                agentUsername ? setShowVPPPopup(true) :  props.history.push('/cloud/fibre/sales/contactInformation');
                context.setShowSpinner(false);
              }
            }
          }
        })
        .catch(error => {

          if (error.status === 400) {

            if (error?.data?.messages[0].message.includes('blocked')) {

              setAccountBlockedMsg(error.data.messages[0].message);
              setOtpScreenVisible(true);
              tagOnOtpError(error.data.messages[0].message);
            }
          } else {

            window.scrollTo(0, 0);
            tagOnOtpError(error?.data?.message);
            props.history.push('/cloud/fibre/sales/error');
          }

          context.setShowSpinner(false);
        });

    } else {

      window.scrollTo(0, 0);
      context.setShowSpinner(false);
      context.setIsUserExisting(false);
      props.history.push('/cloud/fibre/sales/document-notes');
    }
  };

  const updatedDropDownSelection = (option) => {

    setSelectedAddressType(option);
    setShowOptions(!showOptions);
    context.setDeliveryAddressType(option);
  };

  const closeError = () => {

    setHasError(false);
  };

  const callSubmitFunction = () => {

    submitLead(context)
      .then((res) => {

        context.setUserDetails({
          key: 'referenceNo',
          value: res.result && res.result.referenceNumber
        });
        window.scrollTo(0, 0);
        props.history.push('/cloud/fibre/sales/success');
        context.setShowSpinner(false);
      })
      .catch((error) => {

        console.error('[Quotation][submitSalesOrder][submitSalesOrder-Failed]');
        console.error(error);

        if (formSubmitAttempt < 3) {

          setHasError(true);
          setFormSubmitAttempt(formSubmitAttempt + 1);
        } else {

          setHasError(false);
          context.setNewCustomerErrorObject(error);
          window.scrollTo(0, 0);
          props.history.push('/cloud/fibre/sales/error');
        }
        context.setShowSpinner(false);
      });
  };

  const submitOrder = () => {

    setHasError(false);
    context.setShowSpinner(true);
    callSubmitFunction();
  };

  useEffect(() => {
    setSelectedAddressType(context.deliveryAddressType);
  }, [ context.deliveryAddressType ]);

  useEffect(() => {

    tagOnDeliveryPageLoad(context?.selectedContractTerm?.duration);
    updatedDropDownSelection(context.deliveryAddressType || 'Same as installation address');
    addBeforeloadEvent();

    return () => {

      removeBeforeloadEvent();
    };
  }, []);

  const back = () => {

    props.history.push('/cloud/fibre/sales/planDetails');
  };

  return (

    <div className='delivery-address-main-wrapper'>

      { hasError && <SubmitLeadRequestError close={closeError} reSubmit={submitOrder} /> }

      <div className="delivery-address-back" onClick={back}>

        <div className="delivery-address-back-arrow">
          <VettingLeftArrow />
        </div>

        <span>
          Back
        </span>
      </div>

      <div className='delivery-address-main-section'>

        <div className='delivery-address-inputs'>

          <PersonalDetails setValidPersonalDetails={(value) => setValidPersonalDetails(value)} />

          <div className="delivery-address-wrapper">

            <div className="delivery-address-heading" >

              <div className="delivery-address-icon">
                <DeliveryAddressIcon />
              </div>

              Delivery address
            </div>

            <hr className='delivery-address-hr'/>

            <div className="delivery-address-section">

              <div className="delivery-address-dropdown-wrapper">

                <FormFieldLabel>
                  Where should we deliver your router?
                </FormFieldLabel>

                <VettingDropDown
                  selectedValue={selectedAddressType}
                  placeholder={'Where should we deliver your router?'}
                  options={[ 'Same as installation address', 'To another address' ]}
                  updateSelectedOption={(option) => updatedDropDownSelection(option)}/>
              </div>

              { (selectedAddressType && selectedAddressType?.toUpperCase() === 'Same as installation address'.toUpperCase())
                ? <SameAddress enableNext={(value) => setEnableNext(value)} />
                : null
              }

              { (selectedAddressType && selectedAddressType?.toUpperCase() === 'To another address'.toUpperCase())
                ? <AnotherAddress enableNext={(value) => setEnableNext(value)} />
                : null
              }
            </div>
          </div>
        </div>

        <div className='delivery-address-summary'>

          <AuthInfoReview
            enableNext={(enableNext && validPersonalDetails)}
            nextClick={isExistingUser} />
        </div>

        <div className='delivery-address-summary-mobile'>

          <AuthInfoReviewMobile
            enableNext={(enableNext && validPersonalDetails)}
            nextClick={isExistingUser} />
        </div>

      </div>

      { otpScreenVisible

        ? <OtpScreen
          history={props.history}
          close={() => setOtpScreenVisible(false)}
          otpSendToMsg={otpSendToMessage}
          resendOtp={isExistingUser}
          accountBlockedMsg={accountBlockedMsg}
          contactNumberSent={phoneNumberSent}
          contactEmailSent={emailSent}
          contactNumberObscure={phoneNumberValue}
          contactEmailObscure={emailValue}
          otpData={otpData}
          otpLength={6}/>
        : null
      }

      { showVPPPopup &&
        <VPPPopup
          showVPPPopup ={ showVPPPopup}
          close={ () => setShowVPPPopup(false)}
          buttonText ={ 'Okay got it'}
          onClick = { () => window.location.href = '/vodacom/fibre/sales/leads'}
          terms = { VPPPopupTerms }/>
      }

      <AuthInfo />

    </div>
  );
};

export default withRouter(DeliveryAddress);
